import React from "react";
import ProductListing from "@/components/product/ProductListing";

// Reused for /shop and /deals (deals passes onSale via prop below).
export default function ShopPage({ dealsOnly = false }) {
  return <ProductListing title={dealsOnly ? "Flash deals" : "All products"} baseParams={dealsOnly ? { onSale: true } : {}} />;
}
